import * as React from 'react';
import { Error, ErrorCode } from '~/Api/User/ProductGroup/CzReimbursement';

export const EmptyResultReason: React.FunctionComponent<React.PropsWithChildren<{ error: Error }>> = ({ error }) => {
	switch (error.code) {
		case ErrorCode.OnlyOneProductPerCountryErrorCode:
			return <p>Calculation requires at most one product for each country</p>;
		case ErrorCode.RequiredProductSettingsMissingErrorCode:
			return <p>Required product settings is missing</p>;
		case ErrorCode.RequiresReferenceSettingsErrorCode:
			return <p>Required reference settings is missing</p>;
		case ErrorCode.RequiresAtLeastOneReferenceCountryProduct:
			return <p>Calculation requires at least one reference country product</p>;
		case ErrorCode.RequiresAtLeastOneProduct:
			return <p>Calculation requires at least one product</p>;
		case ErrorCode.RequiresAtLeastOneProductList:
			return <p>Calculation requires at least one product list</p>;
		default:
			return null;
	}
};
